import * as formats from "../../../../common/formats";

require('select2');
require('tempusdominus-bootstrap-4');

// 詳細画面
$(() => {
    if (document.getElementById('agent-list') != null) {
        setUpState();
        changeState();

        $('#companyUser').select2({
            placeholder: "選択してください",
            allowClear: true
        });

        $('#companyUser').on('change', function(e) {
            var form = $('#form');

            form = setStatus(form);
            form = setAgent(form);
            form = setLabels(form);
            form = setWord(form);

            form.submit();
        });

        $('#labels').on('change', function(e) {
            var form = $('#form');

            form = setStatus(form);
            form = setAgent(form);
            form = setLabels(form);
            form = setWord(form);

            form.submit();
        });
    }
});

/**
 * 送信情報にワードを設定する
 * @param form
 * @returns {*}
 */
function setWord(form)
{
    $('<input>').attr({
        'type': 'hidden',
        'name': 'word',
        'value': $('[name="word"]').val()
    }).appendTo(form);
    return form;
}

/**
 * 送信情報にラベルを設定する
 * @param form
 * @returns {*}
 */
function setLabels(form)
{
    $('<input>').attr({
        'type': 'hidden',
        'name': 'labels',
        'value': $('[name="labels"]').val()
    }).appendTo(form);
    return form;
}
/**
 * 送信情報にclient_userを設定する
 * @param form
 * @returns {*}
 */
function setAgent(form)
{
    // 担当者情報の設定
    $('<input>').attr({
        'type': 'hidden',
        'name': 'agent_user',
        'value': $('[name="agent_user"]').val()
    }).appendTo(form);
    return form;
}

/**
 * 送信情報にstatusを設定する
 */
function setStatus(form)
{
    // status情報の確保
    if ($('input[name="status[all]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'all',
            'value': 1
        }).appendTo(form);
    }
    if ($('input[name="status[making]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'making',
            'value': 1
        }).appendTo(form);
    }
    if ($('input[name="status[before_operation]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'before',
            'value': 1
        }).appendTo(form);
    }
    if ($('input[name="status[in_operation]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'in',
            'value': 1
        }).appendTo(form);
    }
    if ($('input[name="status[end_operation]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'end',
            'value': 1
        }).appendTo(form);
    }
    if ($('input[name="status[cancellation]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'cancellation',
            'value': 1
        }).appendTo(form);
    }
    if ($('input[name="status[stop_operation]"]').val() == 1) {
        $('<input>').attr({
            'type': 'hidden',
            'name': 'stop_operation',
            'value': 1
        }).appendTo(form);
    }
    return form;

}



/**
 * status検索項目の変更
 */
function changeState() {
    // 全て
    $('#js-status-all').on('click', function(e) {
        // 複数選択の処理(今後復活する可能性がるので)
        // var all = $('input:hidden[name="status[all]"]');
        // if(all.val() == 0) {
        //     // 選択済みに変更
        //     $('#js-status-all').css({
        //         'background-color' : '#4285f4',
        //         'color' : 'white'
        //     });
        //     all.val(1);
        // }
        // else {
        //     // 非選択に変更
        //     $('#js-status-all').css({
        //         'background-color' : 'darkgray',
        //         'color' : 'black'
        //     });
        //     all.val(0);
        // }
    });
    // 作成中
    $('#js-status-making').on('click', function(e) {
        // var making = $('input:hidden[name="status[making]"]');
        // if(making.val() == 0) {
        //     // 選択済みに変更
        //     $('#js-status-making').css({
        //         'background-color' : '#4285f4',
        //         'color' : 'white'
        //     });
        //     making.val(1);
        // }
        // else {
        //     // 非選択に変更
        //     $('#js-status-making').css({
        //         'background-color': 'darkgray',
        //         'color' : 'black'
        //     });
        //     making.val(0);
        // }

        sendStatus({
            'all' : 0,
            'making' :  1,
            'before_operation' : 0,
            'in_operation' : 0,
            'end_operation' : 0,
            'cancellation' : 0,
            'stop_operation' : 0,
        });
    });
    // 稼働前
    $('#js-status-before_operation').on('click', function(e) {
        var before_operation = $('input:hidden[name="status[before_operation]"]');
        if(before_operation.val() == 0) {
            // 選択済みに変更
            $('#js-status-before_operation').css({
                'background-color' : '#4285f4',
                'color' : 'white'
            });
            before_operation.val(1);
        }
        else {
            // 非選択に変更
            $('#js-status-before_operation').css({
                'background-color': 'darkgray',
                'color' : 'black'
            });
            before_operation.val(0);
        }
    });
    // 稼働中
    $('#js-status-in_operation').on('click', function(e) {
        var in_operation = $('input:hidden[name="status[in_operation]"]');
        if(in_operation.val() == 0) {
            // 選択済みに変更
            $('#js-status-in_operation').css({
                'background-color' : '#4285f4',
                'color' : 'white'
            });
            in_operation.val(1);
        }
        else {
            // 非選択に変更
            $('#js-status-in_operation').css({
                'background-color': 'darkgray',
                'color' : 'black'
            });
            in_operation.val(0);
        }
    });
    // 稼働満了
    $('#js-status-end_operation').on('click', function(e) {
        var end_operation = $('input:hidden[name="status[end_operation]"]');
        if(end_operation.val() == 0) {
            // 選択済みに変更
            $('#js-status-end_operation').css({
                'background-color' : '#4285f4',
                'color' : 'white'
            });
            end_operation.val(1);
        }
        else {
            // 非選択に変更
            $('#js-status-end_operation').css({
                'background-color': 'darkgray',
                'color' : 'black'
            });
            end_operation.val(0);
        }
    });
    // 解約
    $('#js-status-cancellation').on('click', function(e) {
        var cancellation = $('input:hidden[name="status[cancellation]"]');
        if(cancellation.val() == 0) {
            // 選択済みに変更
            $('#js-status-cancellation').css({
                'background-color' : '#4285f4',
                'color' : 'white'
            });
            cancellation.val(1);
        }
        else {
            // 非選択に変更
            $('#js-status-cancellation').css({
                'background-color': 'darkgray',
                'color' : 'black'
            });
            cancellation.val(0);
        }
    });
    // 稼働休止
    $('#js-status-stop_operation').on('click', function(e) {
        var stop_operation = $('input:hidden[name="status[stop_operation]"]');
        if(stop_operation.val() == 0) {
            // 選択済みに変更
            $('#js-status-stop_operation').css({
                'background-color' : '#4285f4',
                'color' : 'white'
            });
            stop_operation.val(1);
        }
        else {
            // 非選択に変更
            $('#js-status-stop_operation').css({
                'background-color': 'darkgray',
                'color' : 'black'
            });
            stop_operation.val(0);
        }
    });
}

/**
 * status検索項目の設定
 */
function setUpState()
{
    var all = $('input:hidden[name="status[all]"]').val();
    var making = $('input:hidden[name="status[making]"]').val();
    var before_operation = $('input:hidden[name="status[before_operation]"]').val();
    var in_operation = $('input:hidden[name="status[in_operation]"]').val();
    var end_operation = $('input:hidden[name="status[end_operation]"]').val();
    var cancellation = $('input:hidden[name="status[cancellation]"]').val();
    var stop_operation = $('input:hidden[name="status[stop_operation]"]').val();

    // 全て
    if(all == 0) {
        $('#js-status-all').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-all').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }

    // 作成中
    if(making == 0) {
        $('#js-status-making').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-making').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }

    // 稼働前
    if(before_operation == 0) {
        $('#js-status-before_operation').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-before_operation').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }
    // 稼働中
    if(in_operation == 0) {
        $('#js-status-in_operation').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-in_operation').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }
    // 稼働満了
    if(end_operation == 0) {
        $('#js-status-end_operation').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-end_operation').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }
    // 解約
    if(cancellation == 0) {
        $('#js-status-cancellation').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-cancellation').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }
    // 稼働中休止
    if(stop_operation == 0) {
        $('#js-status-stop_operation').css('background-color', 'darkgray');
    }
    else {
        $('#js-status-stop_operation').css({
            'background-color' : '#4285f4',
            'color' : 'white'
        });
    }

}
